import axios from 'axios';

const API_URL = process.env.REACT_APP_BASEURL + 'attendance';

// Save attendance
export const saveAttendance = (reqData: any) => {
  return axios.post(API_URL + '/save', reqData);
};

// Get attendance for class + subject + date
export const getAttendance = (params: any) => {
  return axios.get(API_URL + '/get', { params });
};

// Update single student attendance
export const updateAttendance = (id: string, reqData: any) => {
  return axios.patch(API_URL + `/update/${id}`, reqData);
};

// Attendance report
export const getAttendanceReport = (params: any) => {
  return axios.get(API_URL + '/report', { params });
};
export const deleteAttendance = (id: string) => {
  return axios.delete(API_URL + `/${id}`);
};
